import React from 'react';

import NumberWidget from './NumberWidget';

const PercentWidget = (props) => {
  const extended = Object.assign({}, props, {
    format: '.2%',
    smallFormat: '.1%',
    hideChangeValue: true,
  });
  return React.createElement(NumberWidget, extended);
};

PercentWidget.defaultProps = NumberWidget.defaultProps;
PercentWidget.propTypes = NumberWidget.propTypes;

export default PercentWidget;
